// extracted by mini-css-extract-plugin
export default {"btn":"WebfitButton_btn__njx-e","disabled":"WebfitButton_disabled__Da-tL","invert":"WebfitButton_invert__lAUoW"};